var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWaterFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0a12 12 0 1 0 12 12A12.035 12.035 0 0 0 12 0z",
    fill: "#00c4ff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f5f5f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.791 26.808A1.8 1.8 0 0 0 18.581 25c0-1-1.791-3.56-1.791-3.56S15 24 15 25a1.8 1.8 0 0 0 1.791 1.812m.8-2.4a.465.465 0 1 1-.46.466.463.463 0 0 1 .46-.466",
    transform: "translate(-4.791 -5.367)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.515 0h-12v2.081l4.471 4.711v5.118l3.044-2.085V6.744l4.482-4.674zm-5.057 9.5-1.9 1.3V7h1.9zm.148-3.161h-2.242L8.309 2.07H18.7zm4.338-4.869H8.072V.6h10.872z",
    transform: "translate(-1.515 3.56)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterFilter);
export default __webpack_public_path__ + "static/media/water-filter.33af0b33df0dde9225d426315e3d932d.svg";
export { ForwardRef as ReactComponent };